/**
 * Paleta de colores institucional LLA
 * Colores primarios y de soporte según brand guidelines
 */

export const BRAND_COLORS = {
  // Colores Primarios
  primary: {
    orange: '#F26522',      // PMS Bright Orange
    darkGray: '#333333',    // PMS 439c
    midGray: '#808080',     // PMS 424c
    white: '#FFFFFF'
  },

  // Colores de Soporte (por equipo)
  support: {
    purple: '#831F82',      // People Team - PMS 2613c
    green: '#50A028',       // Finance Team - PMS 2424c
    blue: '#004F9F',        // Legal Team - PMS 280c
    darkOrange: '#D90019',  // Technology Team - PMS 186c
    yellow: '#FFA626',      // Customer Team - PMS 143c
    midOrange: '#FF1926'    // Strategy Team - PMS Bright Red
  },

  // Gradientes institucionales
  gradients: {
    orange: 'linear-gradient(-30deg, #F26522 70%, #F26522CC 100%)',
    gray: 'linear-gradient(-30deg, #808080 60%, #333333 100%)',
    purple: 'linear-gradient(-30deg, #831F82 60%, #831F8266 100%)',
    blue: 'linear-gradient(-30deg, #004F9F 60%, #004F9F4D 100%)',
    green: 'linear-gradient(-30deg, #50A028 60%, #50A02866 100%)',
    yellow: 'linear-gradient(-30deg, #FFA626 60%, #FFA62666 100%)',
    darkOrange: 'linear-gradient(-30deg, #D90019 60%, #D9001966 100%)'
  },

  // Variaciones para UI
  ui: {
    // Backgrounds
    backgroundLight: '#FAFAFA',
    backgroundCard: '#FFFFFF',
    
    // Borders
    borderLight: '#E5E5E5',
    borderMedium: '#CCCCCC',
    
    // Text
    textPrimary: '#333333',
    textSecondary: '#808080',
    textLight: '#AAAAAA',
    
    // Status colors usando paleta institucional
    success: '#50A028',     // Verde institucional
    warning: '#FFA626',     // Amarillo institucional
    error: '#D90019',       // Rojo institucional
    info: '#004F9F',        // Azul institucional
    
    // Shadows
    shadowLight: '0 1px 3px rgba(51, 51, 51, 0.1)',
    shadowMedium: '0 4px 6px rgba(51, 51, 51, 0.1)',
    shadowLarge: '0 10px 15px rgba(51, 51, 51, 0.1)',
    shadowXL: '0 20px 25px rgba(51, 51, 51, 0.1)'
  }
};

// Utilidades para usar los colores
export const getCloudProviderColor = (providerId) => {
  const colorMap = {
    'aws-lla': BRAND_COLORS.primary.orange,
    'aws-cr': BRAND_COLORS.support.blue,
    'gcp-lla': BRAND_COLORS.support.green,
    'azure': BRAND_COLORS.support.purple,
    'oci': BRAND_COLORS.support.darkOrange
  };
  
  return colorMap[providerId] || BRAND_COLORS.primary.midGray;
};

export const getCloudProviderGradient = (providerId) => {
  const gradientMap = {
    'aws-lla': BRAND_COLORS.gradients.orange,
    'aws-cr': BRAND_COLORS.gradients.blue,
    'gcp-lla': BRAND_COLORS.gradients.green,
    'azure': BRAND_COLORS.gradients.purple,
    'oci': BRAND_COLORS.gradients.darkOrange
  };
  
  return gradientMap[providerId] || BRAND_COLORS.gradients.gray;
};
